import { render } from "./ActivateWarrantyPlan.vue?vue&type=template&id=5194291e&scoped=true&ts=true"
import script from "./ActivateWarrantyPlan.vue?vue&type=script&lang=ts"
export * from "./ActivateWarrantyPlan.vue?vue&type=script&lang=ts"

import "./ActivateWarrantyPlan.vue?vue&type=style&index=0&id=5194291e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5194291e"]])

export default __exports__